import { useState, useEffect } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { fmtEur } from "@/lib/format";

const inp = "w-full bg-[#1A2335] border border-[#222D42] rounded-lg px-3 py-2 text-sm text-slate-100 focus:outline-none focus:border-amber-500/50";

export const DeleteExpenseDialog = ({ expense, onClose, onDone }) => {
  const confirm = async () => {
    try { await api.deleteExpense(expense.id); toast.success("Spesa eliminata"); onDone(expense.id); }
    catch { toast.error("Errore nell'eliminazione"); }
    onClose();
  };
  return (
    <AlertDialog open={!!expense} onOpenChange={(o) => { if (!o) onClose(); }}>
      <AlertDialogContent data-testid="delete-expense-dialog" className="bg-[#121824] border-[#222D42] text-slate-100">
        <AlertDialogHeader>
          <AlertDialogTitle>Eliminare questa spesa?</AlertDialogTitle>
          <AlertDialogDescription className="text-slate-400">
            {expense && <>"{expense.description || expense.category}" da {fmtEur(expense.amount)} verrà eliminata definitivamente.</>}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="delete-expense-cancel" className="bg-[#1A2335] border-[#222D42] text-slate-200 hover:bg-[#222D42] hover:text-slate-100">Annulla</AlertDialogCancel>
          <AlertDialogAction data-testid="delete-expense-confirm" onClick={confirm} className="bg-red-500 hover:bg-red-400 text-white">Elimina</AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export const EditExpenseDialog = ({ expense, onClose, onDone }) => {
  const [f, setF] = useState(null);
  useEffect(() => { setF(expense ? { description: expense.description || "", amount: expense.amount || 0, date: expense.date || "" } : null); }, [expense]);
  if (!expense || !f) return null;
  const save = async () => {
    if (!f.description.trim()) return toast.error("Inserisci una descrizione");
    try {
      const upd = await api.updateExpense(expense.id, { ...expense, description: f.description.trim(), amount: Number(f.amount) || 0, date: f.date || null });
      toast.success("Spesa aggiornata"); onDone(upd); onClose();
    } catch { toast.error("Errore nel salvataggio"); }
  };
  return (
    <AlertDialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <AlertDialogContent data-testid="edit-expense-dialog" className="bg-[#121824] border-[#222D42] text-slate-100">
        <AlertDialogHeader><AlertDialogTitle>Modifica spesa in contanti</AlertDialogTitle></AlertDialogHeader>
        <div className="space-y-3">
          <div><label className="text-[11px] uppercase text-slate-500">Descrizione</label><input data-testid="edit-expense-desc" value={f.description} onChange={(e) => setF({ ...f, description: e.target.value })} className={inp} /></div>
          <div className="grid grid-cols-2 gap-3">
            <div><label className="text-[11px] uppercase text-slate-500">Importo (€)</label><input data-testid="edit-expense-amount" type="number" value={f.amount} onChange={(e) => setF({ ...f, amount: e.target.value })} className={`${inp} font-mono`} /></div>
            <div><label className="text-[11px] uppercase text-slate-500">Data</label><input data-testid="edit-expense-date" type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className={inp} /></div>
          </div>
        </div>
        <AlertDialogFooter>
          <AlertDialogCancel data-testid="edit-expense-cancel" className="bg-[#1A2335] border-[#222D42] text-slate-200 hover:bg-[#222D42] hover:text-slate-100">Annulla</AlertDialogCancel>
          <button data-testid="edit-expense-save" onClick={save} className="bg-amber-500 hover:bg-amber-400 text-slate-950 font-semibold px-4 py-2 rounded-md text-sm">Salva</button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
